import React from 'react';
import { Card, CardContent, Box, Typography, Link as MuiLink } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styles from './EVNDetailsSummaryCard.styles';

import { useNavWithTrail } from '../../../../layouts/TrailProvider';

export default function EVNDetailsSummaryCard({ summaryFields = [], dash, evnId }) {
  const navigate = useNavigate();
  const nav = useNavWithTrail(navigate);

  const handleNav = (link) => {
    if (!link) return;
    nav(link);
  };

  const fmtGB = (v) => (v ? new Date(v).toLocaleString('en-GB') : '—');

  return (
    <Card sx={styles.summaryCard}>
      <CardContent sx={styles.summaryCardContent}>
        <Box sx={styles.contentRow}>
          {summaryFields.map(([label, value, isDate, link]) => (
            <Box key={label} sx={styles.item}>
              <Box sx={styles.textBox}>
                <Typography sx={styles.label}>{label}</Typography>

                {link ? (
                  value ? (
                    <MuiLink
                      underline="none"
                      sx={styles.link}
                      onClick={() => handleNav(link)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          handleNav(link);
                        }
                      }}
                      role="link"
                      tabIndex={0}
                      aria-label={`Go to ${value}`}
                    >
                      {dash(value)}
                    </MuiLink>
                  ) : (
                    <Typography sx={styles.value}>—</Typography>
                  )
                ) : (
                  <Typography sx={styles.value}>{isDate ? fmtGB(value) : dash(value)}</Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
